import React from "react";
import { CaseStageEnum } from "../../../../../src/api/caseStages";
import { useAppSelector } from "../../../../../src/app/store";
import { selectStageConfigByStage } from "../../logic/slice";
import WorkflowStageBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageBanner";
import WorkflowStageInfoBanner from "../../../../../src/features/stageWorkflow/components/WorkflowStageInfoBanner";
import {selectCurrentCaseStage } from "../../../../../src/features/caseinfo/logic/Slice";
import { useUserGroupMembership } from "../../../../../src/features/auth/logic/rbac";


const FrmdAdminIoAppAuthReviewStage: React.FC = () => {
  const { isFrmdAdmin } = useUserGroupMembership();

  const stageConfig = useAppSelector(selectStageConfigByStage(CaseStageEnum.FRMD_ADMIN_IO_APP_AUTH_REVIEW));

  const currentStage = useAppSelector(selectCurrentCaseStage);

  const notes = currentStage?.stage_data?.notes;

  if (isFrmdAdmin) {
    return (
      <WorkflowStageBanner
        title="Confirm IO Appointing Authority"
        description="Review the proposed IO Appointing authority. Your confirmation empowers designated authority to appoint Investigating Officer for further actions."
        actions={stageConfig?.actions}
        notes={notes}
      />
    );
  }

  return (
    <WorkflowStageInfoBanner
      title="Pending with FRMD to Confirm IO Appointing Authority"
    />
  );
};

export default FrmdAdminIoAppAuthReviewStage;
